/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-08 11:07:37
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-12 17:03:21
 * @FilePath: /unifyxp-v2-store-portal/src/config/routerConfig/mainPages/index.ts
 */
import loadable from 'src/constrains/Loadable';

//const Page = loadable(() => import('src/pages/Homepage/Homepage'));

const CreateNewOrder = loadable(
  () => import('src/pages/Order/AllOrders/CreateNewOrder'),
);
const OrderDetail = loadable(
  () => import('src/pages/Order/AllOrders/OrderDetail'),
);
const OrderGiftCardEdit = loadable(
  () => import('src/pages/Order/GiftCardAndStoreCredit/Detail'),
);
const OrderGiftCardList = loadable(
  () => import('src/pages/Order/GiftCardAndStoreCredit/List'),
);
const OrderList = loadable(() => import('src/pages/Order/AllOrders/OrderList'));
const OrderShoppingCartList = loadable(
  () => import('src/pages/Order/ShoppingCartTemplate/List'),
);
const OrderSubscriptionBuyEdit = loadable(
  () => import('src/pages/Order/SubscriptionBuy/SubscriptionBuyEdit'),
);
const OrderSubscriptionBuyList = loadable(
  () => import('src/pages/Order/SubscriptionBuy/List'),
);
const ShoppingCartTemplateDetail = loadable(
  () =>
    import('src/pages/Order/ShoppingCartTemplate/ShoppingCartTemplateDetail'),
);
const StoreVoucherEdit = loadable(
  () => import('src/pages/StoreVoucher/Detail'),
);
const StoreVoucherList = loadable(() => import('src/pages/StoreVoucher/List'));

const Test = loadable(() => import('src/pages/Test'));

const NoPermission = loadable(() => import('src/pages/NoPermission'));

// const editorRoutes = loadable(() => import('./EditorPage'));
// const listRoutes = loadable(() => import('./ListPage'));
// const settingRoutes = loadable(() => import('./SettingPage'));

//import NotFound from 'src/pages/404';

// import Test from 'src/pages/Test';
import { storeRoutes } from 'src/tools/urlMap';
import { editorRoutes } from './EditorPage';
import { listRoutes } from './ListPage';
import settingRoutes from './SettingPage';

import { IRouteSubRoutes } from 'src/types/router';
import {
  //EnumResources,

  EPermissionSource,
} from 'src/types/common/resources';
import {
  voucherListPage,
  voucherDetailPage,
  ordersListPage,
  orderDetailPage,
  giftCardDetailPage,
  giftCardListPage,
  shoppingCartTemplateDetailPage,
  shoppingCartTemplateListPage,
  subscriptionBuyDetailPage,
  subscriptionBuyListPage,
} from '@/src/tools/permissions/storePermissions';
// const SimpleProductEditor = loadable(
// () =>
//   import(
//     /* webpackChunkName:"SimpleProduct" */ '@/src/pages/ProductEditor/SimpleProduct/SimpleProduct'
//   ),
// );
const route: IRouteSubRoutes[] = [
  // {
  //   exact: true,
  //   path: '/',
  //   component: Page,
  //   isPrivate: true,
  //   source: EPermissionSource.store,
  // },

  {
    exact: true,
    path: '/test',
    component: Test,
    isPrivate: true,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.storeVoucherEdit, //'/storeVoucherEdit/:discountUuid',
    component: StoreVoucherEdit,
    isPrivate: true,
    source: EPermissionSource.store,
    permissionGroup: voucherDetailPage,
  },
  {
    exact: true,
    path: storeRoutes.storeVoucherList, //'/storeVoucherList',
    component: StoreVoucherList,
    isPrivate: true,
    permissionGroup: voucherListPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.orderList, //'/orderList',
    component: OrderList,
    isPrivate: true,
    permissionGroup: ordersListPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.orderCreate, //`/orderCreate/:uuid`,
    component: CreateNewOrder,
    isPrivate: true,
    permissionGroup: orderDetailPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.orderDetail, // '/order/:uuid',
    component: OrderDetail,
    isPrivate: true,
    permissionGroup: orderDetailPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.orderShoppingCartList, //'/order/shoppingCart/list',
    component: OrderShoppingCartList,
    isPrivate: true,
    permissionGroup: shoppingCartTemplateListPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.orderShoppingCartDetail, //'/order/shoppingCart/edit/:uuid',
    component: ShoppingCartTemplateDetail,
    isPrivate: true,
    permissionGroup: shoppingCartTemplateDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.orderGiftCardList, //'/order/giftCard/list',
    component: OrderGiftCardList,
    isPrivate: true,
    permissionGroup: giftCardListPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    path: storeRoutes.orderGiftCardDetail, //'/order/giftCard/edit/:uuid',
    component: OrderGiftCardEdit,
    isPrivate: true,
    permissionGroup: giftCardDetailPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.orderSubscriptionBuyList, //'/order/subscriptionBuy/list',
    component: OrderSubscriptionBuyList,
    isPrivate: true,
    permissionGroup: subscriptionBuyListPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.orderSubscriptionBuyDetail, //'/order/subscriptionBuy/edit/:uuid',
    component: OrderSubscriptionBuyEdit,
    isPrivate: true,
    permissionGroup: subscriptionBuyDetailPage,
    source: EPermissionSource.store,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: storeRoutes.permission, //'/permission-forbidden',
    component: NoPermission,
    isPrivate: false,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  //

  //OrderShoppingCartList

  // {
  //   exact: true,
  //   path: '/404',
  //   component: NotFound,
  //   //permissionGroup: [EnumPermissions.CANTEST],
  // },

  ...editorRoutes,
  ...listRoutes,
  ...settingRoutes,
];
export default route;
